export default function Blog() {
  const categories = [
    { icon: 'ri-quill-pen-line', label: 'Writing Journey', color: 'hover:bg-[#353942]' },
    { icon: 'ri-book-open-line', label: 'Book Insights', color: 'hover:bg-[#353942]' },
    { icon: 'ri-lightbulb-line', label: 'Healing Ideas', color: 'hover:bg-[#353942]' },
    { icon: 'ri-calendar-event-line', label: 'Events', color: 'hover:bg-[#353942]' },
    { icon: 'ri-newspaper-line', label: 'Latest News', color: 'hover:bg-[#353942]' }
  ];

  return (
    <section id="blog" className="bg-[#FAF8F5] py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900">
            Latest Insights
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {categories.map((category, index) => (
            <a
              key={index}
              href="#blog"
              className={`bg-[#2A2D34] rounded-2xl p-6 flex items-center gap-4 transition-all duration-300 cursor-pointer ${category.color} hover:-translate-y-1 hover:shadow-xl group`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${category.icon} text-white text-3xl group-hover:scale-110 transition-transform`}></i>
              </div>
              <span className="text-white text-base font-medium">{category.label}</span>
            </a>
          ))}
        </div>

        {/* Blog Posts Preview */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: 'Finding Light in the Darkest Moments',
              date: 'March 15, 2024',
              excerpt: 'Reflections on the journey from trauma to healing and the power of faith in transformation.',
              image: 'https://public.readdy.ai/ai/img_res/247a5099d4937f4ba0606c496a7c65db.jpg',
              searchQuery: 'finding light in darkest moments trauma healing faith transformation'
            },
            {
              title: 'The Power of Sharing Your Story',
              date: 'March 8, 2024',
              excerpt: 'Why vulnerability and authenticity can help others on their own healing journeys.',
              image: 'https://readdy.ai/api/search-image?query=Open%20journal%20with%20handwritten%20pages%20and%20fountain%20pen%20on%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20intimate%20storytelling%20atmosphere%2C%20simple%20clean%20background%20with%20soft%20focus%2C%20professional%20photography%20emphasizing%20personal%20narrative%20and%20authentic%20expression&width=600&height=400&seq=blog-post-002&orientation=landscape',
              searchQuery: 'power of sharing your story vulnerability authenticity healing journey'
            },
            {
              title: 'Building Resilience Through Faith',
              date: 'March 1, 2024',
              excerpt: 'How spiritual practices and community support can strengthen our ability to overcome adversity.',
              image: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20scene%20with%20person%20in%20silhouette%20facing%20sunrise%2C%20warm%20golden%20hour%20lighting%2C%20serene%20natural%20landscape%2C%20simple%20clean%20background%2C%20professional%20photography%20conveying%20spiritual%20strength%20and%20inner%20peace%2C%20hopeful%20uplifting%20composition&width=600&height=400&seq=blog-post-003&orientation=landscape',
              searchQuery: 'building resilience through faith spiritual practices community support overcoming adversity'
            }
          ].map((post, index) => (
            <article key={index} className="group cursor-pointer">
              <a 
                href={`https://www.google.com/search?q=${encodeURIComponent(post.searchQuery)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 bg-white"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <p className="text-xs text-teal-600 font-medium mb-2 uppercase tracking-wider">{post.date}</p>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-teal-600 font-medium text-sm group-hover:gap-3 transition-all">
                    <span>Read More</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
